import { Component, OnInit, Input, EventEmitter, OnDestroy, HostListener, Inject } from '@angular/core';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { GtConfig, GenericTableComponent, GtExpandedRow } from '@angular-generic-table/core';
import * as moment from 'moment';
import { DecimalPipe } from '@angular/common';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-company-dashboard',
  templateUrl: './company-dashboard.component.html'
})
export class CompanyDashboardComponent implements OnInit {

	companyId: number;
	games: any;
	public configObject: GtConfig<any>;

  	constructor(private http: HttpClient) { }

  	ngOnInit() {
  		this.companyId = JSON.parse(localStorage.getItem('currentUser')).userid;

  		this.getGames(this.companyId);
  	}

  	getGames($companyId){
  		return this.http.get(environment.symfonyEndpointSecuredForCompany + environment.apiGetGamesByCompany + $companyId).map((res: Response) => res).subscribe(games => {
      		this.games = games;
      		this.loadDataTable();
     	})
  	}

  	loadDataTable(){
  		this.configObject = {
	      settings:[{
	        objectKey:'picture_url',
	        sort:'disable',
	        search:false
	      },
	      {
	        objectKey:'name',
	        sort:'enable',
	        search:true
	      },
	      {
	        objectKey:'state',
	        sort:'disable',
	        search:true
	      },
	      {
	        objectKey:'invoice',
	        sort:'disable'
	      },
	      {
	        objectKey:'budget',
	        sort:'disable'
	      },
	      {
	        objectKey:'stat',
	        sort:'disable'
	      }],
	      fields:[{
	        name:'',
	        objectKey:'picture_url',
	        columnClass: 'center-column',
	        render: function(row){return '<img src="assets/images/games/' + row.name + '/' + row.picture_url + '" width="100px">'; }
	      },
	      {
	        name:'Nom du jeu',
	        objectKey:'name',
	        expand: {
                component: PrizeComponent,
                data: (row) => [row.prizes, row.name, row.company.name]
            }
	      },
	      {
	        name:'Etat',
	        objectKey:'state',
	        value: function(row){
	        	if(row.status.name == "To be validated")
	        		return '<p>En attente de validation par Uclics</p>';
	        	else if(row.start_date){
		        	if(moment().isSameOrBefore(row.start_date)){
				      return '<p>En attente de lancement le <br> ' + row.start_date;
				    }else if(moment().isSameOrAfter(row.start_date) && moment().isSameOrBefore(row.end_date)){
				      return '<p>Jeu en cours <br>Termine le : ' + row.end_date;
				    }else if(moment().isSameOrAfter(row.end_date)){
				      return 'Terminé';
				    }
				}
	        },
	      },
	      {
	        name:'Facture',
	        objectKey:'invoice',
	        value: function(row){ return 'Facture non crée'}
	        // TODO : dl le pdf de la facture et afficher son N° et son statut (réglée ou non)
	      },
	      {
	        name:'Budget',
	        objectKey:'budget',
	        value: function(row){ 
	        	if(row.max_budget)
	        		return 'TODO / ' + new DecimalPipe('FR').transform(row.max_budget) + ' €';
	        	else
	        		return 'TODO';
	        }
	        // TODO : récup le montant en cours du jeu
	      },
	      {
	        name:'Statistiques',
	        objectKey:'stat',
	        value: function(row){ 
	        	return '<a href="/company/stats/' + row.id + '"><i class="material-icons">insert_chart</i></a>';
	        }
	      },]
	    };
  	}

  	
}


@Component({
  templateUrl: './prize-row.component.html'
})
export class PrizeComponent extends GtExpandedRow<any> implements OnInit {
 
  @Input() data: any;
  prizes: any;
  gameName: string;
  companyName: string;

  constructor(public WinnerPopin: MatDialog) {
  	 super();
  }

  ngOnInit() {
    this.prizes = this.data[0];
    this.gameName = this.data[1];
    this.companyName = this.data[2];
  }

  openPopinWinner($winner): void {
	    this.WinnerPopin.open(PopinWinner, {
	      // panelClass: 'popin-centered',
	      data: { winner: $winner }
	    });
	}
}


@Component({
  selector: 'popin-winner',
  templateUrl: 'popin-winner.html',
})
export class PopinWinner {

  constructor( 
  	public dialogRef: MatDialogRef<PopinWinner>, 
  	@Inject(MAT_DIALOG_DATA) public data: any) { }

  closePopin(): void {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// C:/wamp64/www/Uclics/demo/angular/src/app/components/company/company-dashboard/company-dashboard.component.ts